export default __webpack_public_path__ + "static/media/biz-corporation.406c4902.svg";